import {API_URL, apiGet, apiPost, apiPut, apiDelete} from '../api'
import {ApiRes} from '../../types/api'

export type SlotType =
    | 'leaderboard-banner'
    | 'landing-event'
    | 'popup-event'
    | 'tradermap-card'
    | 'announce-event'
    | 'bottom-sheet'
    | 'account-banner'
    | 'leaderboard-header'

export interface IPromotionItem {
    id?: number
    promotion_set_id: number
    slot: SlotType
    banner_oid?: string // keeping for compatibility if needed, but likely deprecated
    image_source: string
    device: string
    url: string
    background?: string
    created_at?: string
    updated_at?: string
}

export const getPromotionItems = async (
    promotionId: string,
    language?: 'ko' | 'en',
): Promise<ApiRes<IPromotionItem[]>> => {
    // language 전달 시 request header 의 language 를 강제 (언어별 item id 가 다르므로 명시적으로 지정)
    return await apiGet(
        API_URL,
        `admin/promotion/${promotionId}/items`,
        undefined,
        language ? {language} : undefined,
    )
}

export const createPromotionItem = async (promotionId: string, data: Partial<IPromotionItem>): Promise<ApiRes<any>> => {
    return await apiPost(API_URL, `admin/promotion/${promotionId}/item`, data)
}

export const updatePromotionItem = async (
    promotionId: string,
    itemId: number,
    data: Partial<IPromotionItem>,
): Promise<ApiRes<any>> => {
    return await apiPut(API_URL, `admin/promotion/${promotionId}/item/${itemId}`, data)
}

export const deletePromotionItem = async (promotionId: string, itemId: number): Promise<ApiRes<any>> => {
    return await apiDelete(API_URL, `admin/promotion/${promotionId}/item/${itemId}`)
}
